// extracted by mini-css-extract-plugin
export var option = "_3w-1";
export var optionActive = "_3w-2";
export var pill = "_3w-0";